<template>

</template>

<script>
    export default {
        name: "RFID_monitor",
        methods:{
          InitLeftMenu: function () {
            this.$emit('getMessage', '8', '0');
          },
        },
      created() {
          this.InitLeftMenu()
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/9_RFID/RFID_monitor.vue